import { UserLoginClientFinalDto, } from '@lucidlink/dto/web-service-api';
import { generateClientFinalMessage } from '@lucidlink/ts-crypto/scram';
export const prepareClientFinal = async (clientFirstDto, serverFirstDto, password) => {
    const clientFinalMessage = await generateClientFinalMessage(clientFirstDto, serverFirstDto, password);
    return UserLoginClientFinalDto.create(clientFinalMessage);
};
